/**
 * Creates a validator function that checks each property in an `object` against a provided validator function.
 * @typeparam T The type of the `object`'s properties.
 * @param validator The validator function that each property will be checked against.
 */
export const validateProperties = (validator) => {
    return (value, logger, logLabel) => {
        return Object.keys(value).every(key => {
            return validator(value[key], logger, `${logLabel}.${key}`);
        });
    };
};
//# sourceMappingURL=properties.js.map